import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useSearchParamsByKeys = (
  keys: string[] = []
): Record<string, string[] | null> => {
  const [params] = useSearchParams();

  const filters = useMemo(() => {
    const filters: Record<string, string[] | null> = {};
    for (const k of keys) {
      const values = params.getAll(k).filter((value) => value !== '');
      const uniqueValues = [...new Set(values)];

      // Officially JSON stringified params are not supported, but they are still used.
      // We need to work around this case to support global_search.
      // As JSON.parse might return other types then string (e.g. for numbers), the
      // result is wrapped into a string again.
      filters[k] =
        k === 'global_search'
          ? uniqueValues.map((value) => {
              try {
                return value != null ? String(JSON.parse(value)) : value;
              } catch {
                return value;
              }
            })
          : uniqueValues;
    }
    return filters;
  }, [params, keys]);

  return filters;
};
